<template>
    <div>
        <consultoria
            :consultoria="consultoria"
            v-show="mostrarConsultoria"
            :solicitacao="false"
            :services="obterServices()"
            :fornecedor="false"
            @obterConsultoriaAtualizada="obterConsultoriaAtualizada()"
        >
            <template slot="footer">
                <app-btn-voltar></app-btn-voltar>
            </template>
        </consultoria>
        <avaliacao
            :consultoria="consultoria"
            v-if="mostrarAvaliacao"
        ></avaliacao>
    </div>
</template>

<script>
import ConsultoriasServicos from './ConsultoriasServicos'
import Consultoria from '../../componentes/consultorias/Consultoria'
import Avaliacao from './Avaliacao'
import { consultoriaStatus } from '../../ConsultoriaStatus'

export default {
    data() {
        return {
            consultoria: {}
        }
    },

    methods: {
        obterServices() {
            return ConsultoriasServicos
        },

        obterConsultoria() {
            this.$store.dispatch('addRequest')
            ConsultoriasServicos.obterConsultoriaPorId(
                this.$route.params.consultoriaId
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.consultoria = response.data
                    } else {
                        this.$toast.error(
                            'Erro ao obter consultoria!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterConsultoriaAtualizada() {
            this.obterConsultoria()
            this.$store.dispatch('setRecarregar', true)
        }
    },

    computed: {
        mostrarConsultoria() {
            return (
                this.$route.name ==
                'AppSebrae_Consultorias_Gestores_Consultorias_Detalhar'
            )
        },

        mostrarAvaliacao() {
            return (
                this.consultoria &&
                (this.consultoria.status ==
                    consultoriaStatus.CONCLUIDA_SEM_AVALIACAO ||
                    this.consultoria.status ==
                        consultoriaStatus.CONCLUIDA_COM_AVALIACAO)
            )
        }
    },

    mounted() {
        this.obterConsultoria()
    },

    components: {
        Consultoria,
        Avaliacao
    }
}
</script>
